<template>
  <div id="app">
	<router-view/>
  <!--  <div>
		
      <el-button @click="startHacking">测试</el-button>
    </div> -->
	<footer-bar ></footer-bar>
    <child-footer></child-footer>
      <child-footer26></child-footer26>
      <music-bar></music-bar>
  </div>
</template>

<script>
export default {
    data(){
      return{
      }
    },
  mounted() {
  },
  methods: {
    startHacking () {
      this.$notify({
        title: 'It works!',
        type: 'success',
        message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
        duration: 5000
      })
    }
  }
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	width: 100%;
	height: 100%;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue